import axios from "axios";

const env = process.env.REACT_APP_ENV || "dev";

const DEFAULT_API_BASE_URL = "https://api-practice-uat.kinesin.health";

const baseUrl =
  env === "local"
    ? "http://localhost:8082"
    : process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

export const axiosInstance = axios.create({
  baseURL: baseUrl,
});
